module.exports = __webpack_public_path__ + "img/safe-info-default.17770e50.svg";